import {
    undef,
    allowFieldAutoProgress,
    allowInputFieldErrorHighlighting,
    runHPDestinationEmptySearchErrorExperiment
} from './';

function hasEmptyDestination(destination) {
    return !destination;
}

function hasEmptyDestinationValues({destination}) {
    return hasEmptyDestination(destination);
}

function hasFilledDestination(destination) {
    return !hasEmptyDestination(destination);
}

/* istanbul ignore next */
function hasFilledDestinationValues({destination}) {
    return hasFilledDestination(destination);
}

function hasValidDestination(destination) {
    return hasFilledDestination(destination);
}

function hasValidDestinationValues({destination}) {
    return hasValidDestination(destination);
}

function shouldDestinationFieldAutoProgressOnSearchSelected(media, form, destination, changedValues) {
    const {
        settings: {
            isMobile
        }
    } = media;

    return (
        !isMobile &&
        allowFieldAutoProgress(form, destination) &&
        hasValidDestinationValues(changedValues)
    );
}

function showDestinationInputFieldError(media, form, destination, abacus, system) {
    const {
        settings: {
            isMobile
        }
    } = media;

    const {
        latestValues
    } = destination;

    return !isMobile && (
        allowInputFieldErrorHighlighting(form, destination) && !hasValidDestinationValues(latestValues) ||
        runHPDestinationEmptySearchErrorExperiment(abacus, system, form, destination)
    );
}

function showDestinationIcon(form, destination) {
    const {
        options: {
            showIcons
        }
    } = form;

    const {
        options: {
            showIcon
        }
    } = destination;

    return (
        showIcon ||
        showIcons && showIcon === undef
    );
}

export {
    hasEmptyDestination,
    hasEmptyDestinationValues,
    hasFilledDestination,
    hasFilledDestinationValues,
    hasValidDestination,
    hasValidDestinationValues,
    shouldDestinationFieldAutoProgressOnSearchSelected,
    showDestinationInputFieldError,
    showDestinationIcon
};
